export default __webpack_public_path__ + "static/media/diag_divd2.5797218d.svg";